export default __webpack_public_path__ + "resume.pdf";